<div class="h-100 position-relative modal-selection-map"
  [ngClass]="{'dialog-container': dialogParams?.clickMap, 'modal-selection-map--with-error': dialogParams?.clickMap && !addressSelected?.pending && addressSelected?.errors?.outsideMunicipality}">
  <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
  <div *ngIf="dialogParams?.clickMap || (dialogParams?.initialValue?.address && !dialogParams?.clickMap)"
    class="autocomplete-address-container">
    <p class="my-2 px-2 text-bold text-center" *ngIf="!dialogParams?.clickMap">{{dialogParams?.initialValue?.address}}
    </p>
    <app-autocomplete-address [options]="addressOptions" *ngIf="dialogParams?.clickMap"
      [inputFormControl]="addressSelected"></app-autocomplete-address>
  </div>
  <div class="map-container" *ngIf="showModal">
    <app-standard-map [options]="mapOptions" (clickMap)="onClickMap($event)"
      (mapReady)="onMapReady()"></app-standard-map>
    <div class="map-chip map-chip--loading" *ngIf="loadingPolygon">
      <i class="fas fa-circle-notch fa-spin"></i> Cargando polígono…
    </div>
    <div class="map-verify-bar" *ngIf="dialogParams?.clickMap && addressSelected?.pending">
      <i class="fas fa-circle-notch fa-spin mr-1"></i> Verificando ubicación…
    </div>
  </div>
  <div class="col-12 px-2 mt-2"
    *ngIf="dialogParams?.clickMap && !addressSelected?.pending && addressSelected?.errors?.outsideMunicipality as err">
    <div class="geo-error-card">
      <i class="fas fa-map-marked-alt geo-error-card__icon"></i>
      <div class="geo-error-card__body">
        <strong>
          Dirección fuera de {{ err.municipalityName || 'el municipio seleccionado' }}<ng-container
            *ngIf="err.departmentName">, {{ err.departmentName }}</ng-container>
        </strong>
        <span>
          <ng-container *ngIf="err.distanceMeters">A {{ err.distanceMeters | number:'1.0-0' }} m del límite ·
          </ng-container>
          Mueve el pin al área azul del mapa.
        </span>
      </div>
    </div>
  </div>
  <div class="col-md-12 button-container mt-3">
    <button mat-raised-button color="primary" type="button" class="bg-color-primary"
      [disabled]="dialogParams?.clickMap && (addressSelected?.pending || addressSelected?.errors?.outsideMunicipality)"
      (click)="dialogParams?.clickMap ? sendDataMapa() : dialogRef.close()">
      <span *ngIf="dialogParams?.clickMap && addressSelected?.pending">
        <i class="fas fa-circle-notch fa-spin mr-1"></i>Verificando…
      </span>
      <span
        *ngIf="dialogParams?.clickMap && !addressSelected?.pending && addressSelected?.errors?.outsideMunicipality">
        <i class="fas fa-exclamation-circle mr-1"></i>Dirección inválida
      </span>
      <span
        *ngIf="!dialogParams?.clickMap || (!addressSelected?.pending && !addressSelected?.errors?.outsideMunicipality)">
        {{dialogParams?.clickMap ? 'Guardar' : 'Cerrar'}}
      </span>
    </button>
  </div>
</div>
